// extracted by mini-css-extract-plugin
export default {"root":"Nt7kFQ"};